import React, { useState } from 'react'
import "./FilterContainer.css"
import { useDispatch, useSelector } from 'react-redux';
import CustomInput from '../CustomInput/CustomInput';
import { fetchSearchs } from '../../hooks/Search';
function FilterContainer({ exportexcel, searchState, filterState }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);
    const { list: search } = useSelector((state) => state.search);
  const dispatch = useDispatch();
  const [searchText, setsearchText] = useState('');
  const [loading, setLoading] = useState(false)
console.log(search,"searchsearch");

  return (
    <div className='mx-4 filter_container py-3 px-3'>
      <div className='action_container'>
        {exportexcel && <div className='excel_container '>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
            <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z" />
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
          </svg>
          <p className='mb-0'>{currentLocal.home.export}</p>
        </div>}
        {searchState &&
          <div className='search_container'>
            <div className='input_container'>
              <CustomInput
                placeholder={currentLocal?.home?.search}
                value={searchText}
                handleChange={(e) => {
                  setsearchText(e.target.value);
                  dispatch(fetchSearchs(e.target.value))
                    .unwrap()
                    .then(() => {
                      setLoading(false)
                    })
                    .catch((err) => {
                      setLoading(false)

                    });
                }}
              />
            </div>
          </div>

        }
      </div>
      {filterState &&
        <>FilterContainer</>
      }
    </div>
  )
}

export default FilterContainer
